import { render } from "./FooterComponent.vue?vue&type=template&id=dcbef122&scoped=true&ts=true"
import script from "./FooterComponent.vue?vue&type=script&lang=ts"
export * from "./FooterComponent.vue?vue&type=script&lang=ts"

import "./FooterComponent.vue?vue&type=style&index=0&id=dcbef122&scoped=true&lang=css"

import exportComponent from "G:\\MD\\MyFiles\\Work\\Projects\\OshElektro\\SMVueJS\\smv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcbef122"]])

export default __exports__